import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, tap, switchMap } from 'rxjs/operators';
import { BehaviorSubject, from, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
const TOKEN_KEY = environment.storageToken;
const URL = environment.apiUrl;
import { JwtHelperService } from '@auth0/angular-jwt';
import { AlertService } from './alert.service';

const helper = new JwtHelperService();
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isAuthenticated: BehaviorSubject<boolean | null> = new BehaviorSubject<
    boolean | null
  >(null);
  token = '';

  private readonly _CurrentUser = new BehaviorSubject(undefined);

  // Expose the observable$ part of the _todos subject (read only stream)
  readonly currentUser$ = this._CurrentUser.asObservable();

  timeout: any;
  constructor(
    public userService: UserService,
    private router: Router,
    private toastr: ToastrService,
    private alertService: AlertService
  ) {
    this.loadToken();
  }

  async loadToken() {
    const token: any = await JSON.parse(
      localStorage.getItem(TOKEN_KEY) || '{}'
    );
    console.log(token);

    if (token && token.token) {
      this.token = token.token;
      const decodedToken = helper.decodeToken(this.token);
      const expirationDate = helper.getTokenExpirationDate(this.token);
      const isExpired = helper.isTokenExpired(this.token);
      if (isExpired) {
        this.logout();
      } else {
        this.changeUser(token);
        this.isAuthenticated.next(true);
      }
    } else {
      this.isAuthenticated.next(false);
      this.changeUser(undefined);
    }
    // const user = await Storage.get({ key: USER_KEY });
    // if (user && user.value) {
    //   this.changeUser(JSON.parse(user.value));
    // }
  }

  changeUser(user: any) {
    this._CurrentUser.next(user);
  }
  setUserCredentials(credentials: any, remember: boolean) {
    console.log('AQUI');
    if (credentials) {
      const storage = remember ? localStorage : sessionStorage;
      this.isAuthenticated.next(true);
      this.alertService.showSuccess(
        'Sesión iniciada exitosamente',
        'Bienvenido'
      );
      this.router.navigate(['/dashboard/home'], { replaceUrl: true });

      return storage.setItem(TOKEN_KEY, JSON.stringify(credentials));
    } else {
      this.isAuthenticated.next(false);

      sessionStorage.removeItem(TOKEN_KEY);
      return localStorage.removeItem(TOKEN_KEY);
    }
  }

  logout() {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    this.isAuthenticated.next(false);

    this.toastr.warning('se ha cerrado la Sesión');

    this.router.navigate(['/login'], { replaceUrl: true });
  }

  getToken() {
    let storage = null;

    if (localStorage.getItem(TOKEN_KEY)) {
      storage = localStorage;
    }

    if (sessionStorage.getItem(TOKEN_KEY)) {
      storage = sessionStorage;
    }

    if (storage) {
      let credentials = JSON.parse(storage.getItem(TOKEN_KEY) || '{}');
      let token = credentials.token;
      return token;
    }
  }
}
